import React from "react";
import { AngleDown } from "../icon/IconTheme";

const SelectCard = ({ data, ...rest }) => {
	return (
		<div className="select-item">
			<select className="form-control form--control" {...rest}>
				{data &&
					data.map((item, i) => (
						<option value="" key={i}>
							{item.option}
						</option>
					))}
			</select>
			<span className="right-icon">
				<AngleDown />
			</span>
		</div>
	);
};

export default SelectCard;
